import { render, staticRenderFns } from "./SupplierDefinitions.vue?vue&type=template&id=602e40f1&"
import script from "./SupplierDefinitions.vue?vue&type=script&lang=js&"
export * from "./SupplierDefinitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports